import gql from 'graphql-tag';

export const DeleteIncidentLabel = gql`
  mutation DeleteIncidentLabel($organizationId: ID!, $incidentId: ID!, $labelId: ID!) {
    deleteIncidentLabel(organizationId: $organizationId, incidentId: $incidentId, labelId: $labelId) {
      id
    }
  }
`;
